
import React from 'react'

import { render } from 'react-dom'
import { HashRouter } from 'react-router-dom'

import { createTheme, ThemeProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import blue from '@mui/material/colors/blue'

import IndexView from 'components/IndexView'

/** For Local  */
// const HOSTNAME = ''

/** For Production */
const HOSTNAME = 'https://hempsteadtown.com/tohservices'

export default HOSTNAME

const
    ROOT_ELEMENT = document.getElementById('root'),
    THEME = createTheme({
        palette: {
            primary: blue
        }
    })

render(
    <ThemeProvider theme={THEME}>
        <CssBaseline />
        <HashRouter >
            <IndexView />

        </HashRouter>
    </ThemeProvider>,
    ROOT_ELEMENT
)
